import { render, staticRenderFns } from "./KnowledgeContentLinks.vue?vue&type=template&id=05cdf0b4&"
import script from "./KnowledgeContentLinks.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports